import { equals } from "ramda";

function getEnv(): "production" | "staging" | "development" {
  if (equals(location.host, "workforce.upserve.com")) {
    return "production";
  } else if (equals(location.host, "workforce.staging.upserve.com")) {
    return "staging";
  }
  return "development";
}

const ENV = getEnv();

function isDevelopment(): boolean {
  return ENV === "development";
}

function isProduction(): boolean {
  return ENV === "production";
}

export { ENV, isDevelopment, isProduction };
